import { WHATSAPP_NUMBER, trackEvent } from "@/lib/api";
import { useLocation } from "react-router-dom";

export default function WhatsAppButton() {
  const loc = useLocation();
  const msg = loc.pathname.startsWith("/product/")
    ? `Hi Teak Studio — enquiring about ${window.location.href}`
    : "Hi Teak Studio — I'd like to enquire about your pieces.";
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={() => trackEvent("whatsapp_click", { meta: { path: loc.pathname } })}
      data-testid="whatsapp-btn"
      className="fixed bottom-6 left-6 z-40 w-14 h-14 rounded-full flex items-center justify-center transition-transform duration-700 hover:scale-105"
      style={{ background: "#141414", border: "1px solid var(--hairline)" }}
      aria-label="WhatsApp enquiry"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#B8895C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
      </svg>
    </a>
  );
}
